/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  selectDialog,
  selectInvitationId,
  selectStatus,
  toggleDialog,
  updateInvitationId,
} from './invitation.remove.slice';
import { removeInvitationFromOrg } from './invitation.remove.thunk';

export default function useRemoveInvitationFromOrg(orgId, resetInvitations) {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const removeDialog = useSelector(selectDialog);
  const invitationId = useSelector(selectInvitationId);

  const onToggleRemoveDialog = open => dispatch(toggleDialog(open));
  const onUpdateInvitationId = newInvitationId => dispatch(updateInvitationId(newInvitationId));

  useEffect(() => {
    if (status === ThunkStatus.SUCCEEDED) {
      onToggleRemoveDialog(false);
      resetInvitations();
    }

    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const onRemoveInvitationConfirmation = (invitationToRemove) => {
    dispatch(removeInvitationFromOrg({ invitationId: invitationToRemove, orgId }));
  };

  return {
    isLoading,
    removeDialog,
    invitationId,
    updateInvitationId,
    onUpdateInvitationId,
    onRemoveInvitationConfirmation,
    onToggleRemoveDialog,
  };
}
